export const locale = {
  lang: "en-CA",
  data: {
    RELEASENOTE: {
      TITLE: "Release note",
    },
  },
};
